!(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const modalList = document.querySelectorAll("[data-custom-modal-popup]");
    modalList.forEach(function (modal) {
      const modalId = modal.getAttribute("data-target");
      document
        .querySelectorAll('[href="#' + modalId + '"]')
        .forEach(function (link) {
          link.addEventListener("click", function (event) {
            event.preventDefault();
            modal.style.display = "flex";
            document.body.classList.add("no-scroll");
          });
        });

      modal
        .querySelectorAll(".custom-modal-close-button, .custom-modal-mask")
        .forEach(function (element) {
          element.addEventListener("click", function () {
            modal.style.display = "none";
            document.body.classList.remove("no-scroll");
          });
        });
    });
  });
})();
